import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api/client';

function VerifyMagicLink({ setCurrentUser }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('ready');
  const magicToken = searchParams.get('token');

  const handleConfirm = async () => {
    if (status === 'loading') return;

    setStatus('loading');

    try {
      const verifyRes = await api.post(`/api/auth/verify?token=${magicToken}`);
      const sessionToken = verifyRes.data.token;

      localStorage.setItem('X-Auth-Token', sessionToken);
      api.defaults.headers.common['X-Auth-Token'] = sessionToken;

      const userRes = await api.get('/users/me');
      const user = userRes.data;

      setCurrentUser(user);
      localStorage.setItem('user', JSON.stringify(user));

      navigate(user.profileCompleted ? '/' : '/complete-profile', { replace: true });
    } catch (err) {
      console.error('Magic link verification failed:', err);
      setStatus('error');
    }
  };

  if (!magicToken) {
    return <h2>Invalid link — no token found.</h2>;
  }

  return (
    <div style={{ textAlign: 'center', marginTop: '20vh' }}>
      {status === 'ready' && (
        <>
          <h2>You're almost in</h2>
          <p>Confirm this sign-in to continue.</p>
          <button onClick={handleConfirm} className="btn-primary">
            Continue
          </button>
        </>
      )}

      {status === 'loading' && <h2>Signing you in...</h2>}

      {status === 'error' && (
        <>
          <h2>Link expired or already used</h2>
          <p>Please request a new sign-in link.</p>
        </>
      )}
    </div>
  );
}

export default VerifyMagicLink;
